import React from 'react'
import PropTypes from 'prop-types'
import Modal from '../../Modal'
import Button from '../../Button'

const ExclusionModalPriceBanner = ({
  buttonText,
  t,
  title,
  confirmButtonMsg = 'new.home.quickAccess.remove.confirm',
  cancelButtonMsg = 'new.home.quickAccess.remove.cancel',
  message,
  dynamicName,
  renderButton,
  onConfirm: confirmCallback,
  size = 'sm',
  isOpen,
  useControlledState,
  onClose,
}) => {
  const defaultMessage = (
    <div style={{ textAlign: 'center' }}>
      <p style={{ fontSize: '18px' }}>{t('price.banner.params.delete.default')}</p>
      {dynamicName && (
        <p style={{ fontSize: '14px' }}>
          <strong>Dinâmica:</strong><br />{dynamicName}
        </p>
      )}
    </div>
  );

  return (
    <Modal
      isOpen={isOpen}
      useControlledState={useControlledState}
      onCloseModal={onClose}
      buttonText={buttonText}
      center
      size={size}
      showHeader={false}
      showFooter={false}
      renderButton={renderButton}
      renderChildrenWithProps={({ onClose, onConfirm }) => (
        <div className='remove-modal pricebanner-exclusion'>
          <i className='glyph glyph-trash-can color-danger' />
          <p className='title'>{title}</p>
          {typeof message === 'function'
            ? message() || defaultMessage
            : message || defaultMessage}
          <div className='button-row '>
            <Button
              className='btn custom-modal-close-button'
              text={t(cancelButtonMsg)}
              onClick={onClose}
            />
            <Button
              className='btn btn-danger'
              text={t(confirmButtonMsg)}
              onClick={() => {
                confirmCallback?.()
                onConfirm?.()
              }}
            />
          </div>
        </div>
      )}
    />
  );
};

ExclusionModalPriceBanner.propTypes = {
  buttonText: PropTypes.string,
  title: PropTypes.string.isRequired,
  message: PropTypes.any.isRequired,
  dynamicName: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  renderButton: PropTypes.func,
  t: PropTypes.func.isRequired,
  confirmButtonMsg: PropTypes.string,
  cancelButtonMsg: PropTypes.string,
  size: PropTypes.string,
  isOpen: PropTypes.bool,
  useControlledState: PropTypes.bool,
  onClose: PropTypes.func,
}

export default ExclusionModalPriceBanner
